<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
  >
    <v-card>
      <!-- ************************
      ********** TOOLBAR **********
      ************************* -->
      <v-toolbar
        color="primary"
        fixed
      >
        <v-icon class="mr-3">
          {{ IconEnum.basket }}
        </v-icon>
        <v-toolbar-title>{{ $t('title.article_details') }}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            class="btn"
            icon
            @click="$emit('hide')"
          >
            <v-icon>{{ IconEnum.close }}</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <div class="pa-1">
        <!-- *******************************
        ********** CADRAN MONTANT **********
        ******************************** -->
        <screen
          use-amount
        />
        <!-- ***********************
        ********** ECOCUP **********
        ************************ -->
        <ecocup v-show="showEcocup" />

        <v-divider class="py-2 my-1" />
        <!-- *******************************
        ********** LISTE PRODUITS **********
        ******************************** -->
        <v-list
          three-line
          subheader
          class="pb-0"
        >
          <v-list-item
            v-for="(product, i) in products"
            :key="i"
            class="product"
          >
            <div class="mr-3">
              <img
                :src="product.img"
                alt="product"
                height="35"
                width="35"
              >
            </div>
            <div>
              {{ product.label }}
              <br>
              <span class="white darken-1 black--text px-1">{{ product.quantity }}</span> x
              {{ $amount(product.price) }} =
              {{ $amount(product.quantity * product.price) }}
            </div>
            <v-btn
              class="btn"
              icon
              @click="del(product.i, product.j, i)"
            >
              <v-icon>{{ IconEnum.delete }}</v-icon>
            </v-btn>
          </v-list-item>
        </v-list>

        <v-divider class="my-1" />

        <v-btn
          class="bloc ma-0"
          color="success"
          large
          @click="pay"
        >
          {{ $t('button.pay') }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { ActionEnum, LimitTransactionHard, IconEnum } from '@/modules/Enums'

import Ecocup from '../ecocup/Ecocup'
import { $alert, $amount } from '@/modules/Utils'

export default {
  name: 'ProductList',

  components: {
    Ecocup
  },

  props: {
    dialog: { type: Boolean, default: false }
  },

  data () {
    return {
      IconEnum,
      products: [],
      showEcocup: this.$store.state.consignes.length > 0
    }
  },

  computed: {
    total: {
      get () { return this.$store.state.amount },
      set (val) { this.$store.commit('amount', val) }
    },
    nbTransactions () { return this.$store.getters.totalTransactions }
  },

  created () {
    let i = 0
    this.$store.state.listproducts.forEach(cat => {
      let j = 0
      cat.products.forEach(product => {
        if (product && product.quantity > 0) {
          product.i = i
          product.j = j
          this.products.push(product)
        }
        j++
      })
      i++
    })
  },

  methods: {
    $amount,
    del (i, j, index) {
      this.total = this.total - (this.products[index].quantity * this.products[index].price)
      this.$store.dispatch('suppProduct', { i: i, j: j })
      this.products.splice(index, 1)
      this.$emit('suppr', i, j)
      if (this.$store.getters.totalNumberOfConsignesAndProducts === 0) {
        this.$emit('hide')
      }
    },
    pay () {
      if (this.$store.getters.totalNumberOfConsignesAndProducts > 0) {
        if (this.nbTransactions >= LimitTransactionHard) {
          $alert(this.$i18n.t('error.offline_trx_max'))
        } else {
          this.$emit('hide')
          setTimeout(() => {
            this.$router.replace({ name: 'scan-nfc', params: { action: ActionEnum.cashlessDebit, mode: 'product', fromAchat: true } })
          }, 200)
        }
      }
    }
  }
}
</script>

<style scoped>
.product {
  margin-top: -10px;
  max-height: 75px;
  border-bottom: 1px solid grey;
}
.product button {
  position: absolute;
  right: 0;
  top: 20px;
}
</style>
